import {inject, Injectable} from '@angular/core';
import {GridGetService, GridServiceParams, GridServiceResponse} from "../../shared/model/page-grid";
import {IErrorLogsResponse} from "../interfaces/admin-panel.interface";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {AdminPanelFilterService} from "./admin-panel-filter.service";
import {catchError, map, Observable} from "rxjs";
import {removeEmptyParams} from "../../../infrastructure/helper/remove-empty-params";
import moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class ErrorLogsGridService implements GridGetService<IErrorLogsResponse> {
  private readonly baseUrl = 'dbov2/error-logs';
  private readonly http = inject(HttpClient);
  private readonly adminPanelFilterService = inject(AdminPanelFilterService);
  
  getItems({page, sort} : GridServiceParams): Observable<GridServiceResponse<IErrorLogsResponse>>  {
    const filters = this.adminPanelFilterService.filtersValue();

    const params:Record<string, string | number | boolean | string[] | number[]> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      DateFrom: filters?.DateFrom ? moment(filters.DateFrom).format('YYYY-MM-DD') : '',
      DateTo: filters?.DateTo ? moment(filters.DateTo).format('YYYY-MM-DD') : '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IErrorLogsResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
      }));
  }

  getTotalCount(): Observable<number> {
    const filters = this.adminPanelFilterService.filtersValue();

    const params:Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: 1,
      pageNumber: 1,
      DateFrom: filters?.DateFrom ? moment(filters.DateFrom).format('YYYY-MM-DD') : '',
      DateTo: filters?.DateTo ? moment(filters.DateTo).format('YYYY-MM-DD') : '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IErrorLogsResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(
        catchError((error:HttpErrorResponse)=>{
          throw new Error(error?.message || 'Server error');
        }),
        map((response) => {
          if (response && response.pagination && typeof response.pagination.totalItemCount === 'number') {
            return response.pagination.totalItemCount;
          }
          return 0;
        })
      );
  }
}
